import { useTranslate } from '@refinedev/core';

const useStatusDropdown = () => {
  const t = useTranslate();
  const statusDropdown: any[] = [
    {
      label: t('pages.statusDropdown.unificationDone'),
      value: 'unification_done',
    },
    {
      label: t('pages.statusDropdown.unificationCancelled'),
      value: 'unification_cancelled',
    },
    {
      label: t('pages.statusDropdown.dataNotAvailable'),
      value: 'data_not_available',
    },
  ];

  return { statusDropdown };
};

export default useStatusDropdown;
